import {Route, Routes} from "react-router-dom";
import Home from "../pages/Home";
import Swap from "../pages/Swap";
import Pools from "../pages/Pools";
import Farms from "../pages/Farms";
import Vote from "../pages/Vote";
import Chart from "../pages/Chart";

export default function Router() {
    return <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/swap" element={<Swap/>}/>
        <Route path="/pools" element={<Pools/>}/>
        <Route path="/farms" element={<Farms/>}/>
        <Route path="/vote" element={<Vote/>}/>
        <Route path="/charts" element={<Chart/>}/>
    </Routes>;
}